import React, { useEffect, useRef } from "react";
import { Box, Button, HStack, Text, Badge } from "@chakra-ui/react";
import { initSocket } from "../../initSocket";

export default function DriverSimLite({
    tripId,
    start = { lat: -9.7045, lng: 33.2690 }, // near your logs, adjust if you like
    dLat = 0.00025,
    dLng = 0.00030,
    intervalMs = 1000,
    speedKph = 40,
}: {
    tripId: string;
    start?: { lat: number; lng: number; };
    dLat?: number;
    dLng?: number;
    intervalMs?: number;
    speedKph?: number;
}) {
    const socketRef = useRef<any>(null);
    const timerRef = useRef<any>(null);
    const posRef = useRef<{ lat: number; lng: number; }>(start);
    const runningRef = useRef(false);

    useEffect(() => {
        (async () => {
            const socket = await initSocket();
            socketRef.current = socket;
            const join = () => {
                console.log("🚚 DriverSimLite: connecting → joinTripRoom", { tripId, socketId: socket.id });
                socket.emit("joinTripRoom", { tripId });
            };
            if (socket.connected) join();
            socket.on("connect", join);
            socket.on("joinedTripRoom", (ack: any) => console.log("✅ DriverSimLite joined ACK:", ack));
        })();

        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
            runningRef.current = false;
        };
    }, [tripId]);

    const startSim = () => {
        if (runningRef.current) return;
        runningRef.current = true;

        // emit initial
        console.log("📤 [lite] EMIT initial", { tripId, ...posRef.current });
        socketRef.current?.emit("locationUpdate", { tripId, ...posRef.current, speed: speedKph });

        timerRef.current = setInterval(() => {
            // move a little each tick
            posRef.current = {
                lat: +(posRef.current.lat + dLat).toFixed(6),
                lng: +(posRef.current.lng + dLng).toFixed(6),
            };
            console.log("📤 [lite] EMIT tick", posRef.current);
            socketRef.current?.emit("locationUpdate", {
                tripId,
                lat: posRef.current.lat,
                lng: posRef.current.lng,
                speed: speedKph,
            });
        }, intervalMs);
    };

    const stopSim = () => {
        if (timerRef.current) clearInterval(timerRef.current);
        runningRef.current = false;
    };

    return (
        <Box p={3} borderWidth="1px" borderRadius="8px">
            <HStack justify="space-between" mb={2}>
                <Badge colorScheme={runningRef.current ? "green" : "gray"}>
                    {runningRef.current ? "Running" : "Idle"}
                </Badge>
                <HStack>
                    <Button size="sm" colorScheme="blue" onClick={startSim}>Start</Button>
                    <Button size="sm" onClick={stopSim}>Stop</Button>
                </HStack>
            </HStack>
            <Text fontSize="sm">Trip: {tripId}</Text>
            <Text fontSize="sm">Start: {start.lat}, {start.lng}</Text>
            <Text fontSize="sm">Δ: {dLat}, {dLng} every {intervalMs}ms</Text>
        </Box>
    );
}
